import { useMemo, useState, useEffect} from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import LocationChatThread from "./locationChatThread";
import PatientChatThread from "./patientChatThread";
import { useGetMessageUnreadCountQuery } from "../../services/chatService";

export default function SidebarContent(){

    const groupChatContext = useGroupChatContext();
    const {authData, selectedChatTab, setSelectedChatTab, setSelectedChat, selectedLocations} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChatTab: groupChatContext.selectedChatTab,
        setSelectedChatTab: groupChatContext.setSelectedChatTab,
        setSelectedChat: groupChatContext.setSelectedChat,
        selectedLocations: groupChatContext.selectedLocations
    }));

    const [chatTabs, setChatTabs] = useState([{key: 'patient_chats', label: 'Patient Chats', count: 0}, {key: 'location_chats', label: 'Location Chats', count: 0}]);

    const unreadCountParams = selectedLocations ? { location_id: selectedLocations } : null;
    const {data: unreadCount} = useGetMessageUnreadCountQuery(unreadCountParams, {refetchOnMountOrArgChange: true});
    useEffect(() => {
        if(unreadCount){
            setChatTabs(prev => prev.map(tab => ({...tab, count: unreadCount[tab.key]})));
        }
    }, [unreadCount]);

    const handleChatTabChange = (chatTab) => {
        setSelectedChatTab(chatTab.key);
        setSelectedChat({});
    }

    return(
        <div>
            <div className="flex items-center justify-between">
                {chatTabs.map((chatTab) => (
                    <button 
                        key={chatTab.key} 
                        type="button" 
                        className={`flex justify-between items-center w-full gap-x-1.5 px-1 py-2 text-sm font-semibold text-gray-700 whitespace-nowrap ${
                            selectedChatTab === chatTab.key
                                ? `border border-b-2 ${authData?.is_provider ? 'border-b-teal-500' : 'border-b-purple-900'}`
                                : `${authData?.is_provider ? 'hover:bg-teal-400' : 'hover:bg-purple-800'} hover:text-white`
                          }`}
                        id="menu-button" 
                        aria-expanded="true" 
                        aria-haspopup="true"
                        onClick={() => handleChatTabChange(chatTab)}
                    >
                        {chatTab.label}
                        {chatTab.count ? <p className={`h-4 px-1.5 place-content-center rounded-full bg-green-500 text-xs text-slate-200 ${chatTab.count > 99 ? 'min-w-[2rem]' : ''}`}>{chatTab.count}</p> : null}
                    </button>
                ))}
            </div>
            {selectedChatTab == 'patient_chats' ? <PatientChatThread /> : <LocationChatThread />}
        </div>
    )
}